import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import XHR from "i18next-http-backend"

//import commonDe from './locales/de/common.json'
//import translationEn from '../public/locales/en/translation.json'
//import commonEs from './locales/es/common.json'
//import commonFr from './locales/fr/common.json'

// const resources = {
//   //de: { common: commonDe },
//   en: { translation: translationEn },
//   //es: { common: commonEs },
//   //fr: { common: commonFr }
// }



i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // lng: 'en' // <--- turn off for detection to work
    //resources,
    //ns: ['translation'],
    //defaultNS: 'translation',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    
    debug: false,
  })

export default i18n